export default {"src":"/_next/static/media/dashboardBanner.2ff5acf2.svg","height":239,"width":352,"blurWidth":0,"blurHeight":0};